import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import InputGroup from '../../form/input-group';
import CheckboxGroup from '../../form/checkbox-group';
import BirthDateGroup from '../../form/birth-date-group';
import { MediaQuery as MQ } from '../../../media-query';
import { getBirthDate } from '../../../util';
import { isErrorForumName } from '../../../util';

dayjs.extend(customParseFormat);

class Component extends BaseComponent {
    constructor() {
        super();
        this.state = {
            accordionOpen: false,
            formError: null,
            dhe: {
                value: null,
            },
            wrs: {
                value: null,
            },
            privacy_policy: {
                value: null,
                error: null,
            },
            name: {
                value: null,
                error: null,
            },
            email: {
                value: null,
                error: null,
            },
            forum_name: {
                value: null,
                error: null,
            },
            birth_date_month: {
                value: null,
                error: null,
            },
            birth_date_day: {
                value: null,
                error: null,
            },
            birth_date_year: {
                value: null,
                error: null,
            },
            birth_date: {
                value: null,
                error: null,
            },
            password: {
                value: null,
                error: null,
            },
            remember_me: {
                value: null,
                error: null,
            },
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState != this.state) {
            return true;
        }

        if (nextProps.user != this.props.user) {
            return true;
        }

        if (nextProps.ppc != this.props.ppc) {
            return true;
        }

        if (nextProps.submitting != this.props.submitting) {
            return true;
        }

        if (nextProps.submitted != this.props.submitted) {
            return false;
        }

        return false;
    }

    render({ emailError, forumNameError }) {
        const disabled = this.props.submitting || this.state.formError;

        return (
            <forums-signup>
                <form autoComplete='off' onSubmit={this.submit}>
                    <p className='has-text-center'>
                        Please create a Tarot.com account! Your unique username will allow you to post and reply to
                        topics in the forums and personalize your forums profile page. Plus, a membership comes with
                        many other great perks! <a href='#' onClick={this.toggleAccordion}>Learn More</a>
                    </p>
                    {this.renderAside()}
                    <row>
                        <column>
                            <InputGroup
                                type='text'
                                name='name'
                                label='Your Name'
                                value={this.state.name.value}
                                error={this.state.name.error}
                                onInput={this.setFormValues}
                            />
                        </column>
                    </row>
                    <row>
                        <column>
                            <InputGroup
                                type='email'
                                name='email'
                                label='Your Email'
                                value={this.state.email.value}
                                error={this.state.email.error || emailError}
                                onInput={this.setFormValues}
                            />
                        </column>
                    </row>
                    <row>
                        <column>
                            <InputGroup
                                type='text'
                                name='forum_name'
                                label='Your Forums Username'
                                value={this.state.forum_name.value}
                                error={this.state.forum_name.error || forumNameError}
                                onInput={this.setFormValues}
                            />
                        </column>
                    </row>
                    <BirthDateGroup
                        name='birth_date'
                        label='Your Birth Date'
                        date={this.state.birth_date}
                        month={this.state.birth_date_month}
                        day={this.state.birth_date_day}
                        year={this.state.birth_date_year}
                        onChange={this.setFormValues}
                    />
                    <row>
                        <column>
                            <InputGroup
                                type='password'
                                name='password'
                                label='Password'
                                value={this.state.password.value}
                                error={this.state.password.error}
                                onInput={this.setFormValues}
                            />
                        </column>
                    </row>
                    <row>
                        <column className='is-12'>
                            <CheckboxGroup
                                name='dhe'
                                label='Get my FREE Daily Horoscope emails'
                                checked={this.state.dhe.value}
                                onChange={this.setFormValues}
                            />
                        </column>
                    </row>
                    <row>
                        <column className='is-12'>
                            <CheckboxGroup
                                name='wrs'
                                label='Get my FREE Weekly Horoscope emails'
                                checked={this.state.wrs.value}
                                onChange={this.setFormValues}
                            />
                        </column>
                    </row>
                    {this.renderPPC()}
                    <row>
                        <column className='has-text-center'>
                            {this.renderError()}
                            <button
                                className={`button ${disabled ? 'disabled' : ''}`}
                                onClick={this.submit}
                                disabled={disabled}
                            >
                                {this.props.submitting ? 'Submitting...' : 'Submit'}
                            </button>
                        </column>
                    </row>
                    {this.renderToS()}
                    <row className='is-hidden'>
                        <column>
                            <label>
                                <input type='checkbox' name='remember_me' onChange={this.setFormValues} />
                                Keep Me Logged In
                            </label>
                        </column>
                    </row>
                </form>
            </forums-signup>
        );
    }

    renderPPC = () => {
        if (!this.props.ppc) {
            return (
                <row>
                    <column className='is-12'>
                        <CheckboxGroup
                            name='privacy_policy'
                            label={'I agree to Tarot.com\'s updated <a href="/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a> and <a href="/terms-of-use" target="_blank" rel="noopener">Terms of Use</a>.'} // eslint-disable-line max-len
                            checked={this.state.privacy_policy.value}
                            error={this.state.privacy_policy.error}
                            onChange={this.setFormValues}
                        />
                    </column>
                </row>
            );
        }

        return null;
    }

    renderToS = () => {
        if (this.props.ppc) {
            return (
                <row>
                    <column className='has-text-center has-padding-20-top'>
                        <small>
                            By continuing, you accept our&nbsp;
                            <a
                                href='/privacy-policy'
                                target='_blank'
                                rel='noopener'
                            >Privacy Policy</a>
                            &nbsp;and&nbsp;
                            <a
                                href='/terms-of-use'
                                target='_blank'
                                rel='noopener'
                            >Terms of Use</a>.
                        </small>
                    </column>
                </row>
            );
        }

        return null;
    }

    submit = (e) => {
        e.preventDefault();
        this.props.setSubmitting(true);

        this.props.userUpdate({
            emailError: null,
            forumNameError: null,
            generalError: null,
        });

        if (this.checkForm() && !this.state.formError) {
            let subscribe_lists = ['ipe'];

            if (this.state.dhe.value) {
                subscribe_lists.push('dailyhoroscope');
                subscribe_lists.push('dle');
            }

            if (this.state.wrs.value) {
                subscribe_lists.push('weekly_love');
            }

            this.props.userSignupApi({
                account_type_id: 1,
                birth_date: this.state.birth_date.value,
                first_name: this.state.name.value,
                display_name: this.state.name.value,
                forum_name: this.state.forum_name.value,
                email: this.state.email.value,
                name: this.state.name.value,
                password: this.state.password.value,
                password_verify: this.state.password.value,
                privacy_policy: true,
                signup_bonus: true,
                signup_gateway: 'forums-signup',
                signup_pfero: true,
                signup_url: window.location.href,
                subscribe_lists: subscribe_lists,
                timezone: (new Date().getTimezoneOffset() / 60) * -1,
                user_name: this.state.name.value,
            });
        }

        this.props.setSubmitting(false);
    }

    /* eslint-disable complexity */
    checkForm = () => {
        let state = this.state;
        state.formError = null;
        const rm = document.querySelector('signup-forums input[name="remember_me"]');

        if (state.remember_me.value || (rm && rm.checked)) {
            state.formError = true;
        }

        if (!state.forum_name.value) {
            state.formError = true;
            state.forum_name = {
                value: null,
                error: 'This field is required',
            };
        }

        if (!state.name.value) {
            state.formError = true;
            state.name = {
                value: null,
                error: 'This field is required',
            };
        }

        if (
            !state.birth_date.value
            ||
            !state.birth_date.value.toString().match(/[0-9]{4}-[0-9]{1,2}-[0-9]{1,2}/)
        ) {
            state.formError = true;
            state.birth_date = {
                value: state.birth_date.value,
                error: 'This field is required',
            };

            if (!MQ.isMobile()) {
                if (!state.birth_date_month.value) {
                    state.birth_date_month = {
                        value: null,
                        error: 'This field is required',
                    };
                }

                if (!state.birth_date_day.value) {
                    state.birth_date_day = {
                        value: null,
                        error: 'This field is required',
                    };
                }

                if (!state.birth_date_year.value) {
                    state.birth_date_year = {
                        value: null,
                        error: 'This field is required',
                    };
                }
            }
        } else {
            const sixteen_years_ago = dayjs().subtract(16, 'year');
            if (dayjs(state.birth_date.value, 'YYYY-MM-DD').isAfter(sixteen_years_ago)) {
                state.formError = 'You must be at least 16 years of age to signup.';
            }
        }

        /* eslint-disable no-useless-escape, max-len */
        const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        /* eslint-enable no-useless-escape, max-len */

        if (!state.email.value) {
            state.formError = true;
            state.email = {
                value: null,
                error: 'This field is required',
            };
        } else if (!regex.test(state.email.value)) {
            state.formError = true;
            state.email = {
                value: state.email.value,
                error: 'Please enter a valid email address',
            };
        }

        if (!state.password.value) {
            state.formError = true;
            state.password = {
                value: null,
                error: 'This field is required',
            };
        } else if (state.password.value.length < 4) {
            state.formError = true;
            state.password = {
                value: state.password.value,
                error: 'Password must be at least 4 characters',
            };
        }

        if (!this.props.ppc && !state.privacy_policy.value) {
            state.formError = 'Please accept Privacy Policy and Terms of Service before continuing';
            state.privacy_policy = {
                value: state.privacy_policy.value,
                error: 'Please accept before continuing.',
            };
        }

        this.setState(state);

        return !state.formError;
    }
    /* eslint-enable complexity */

    renderError = () => {
        if (this.state.formError) {
            return (
                <p className='is-error has-text-center'>{this.state.formError}</p>
            );
        }

        return null;
    }

    renderAside = () => {
        if (this.state.accordionOpen) {
            return (
                <aside className='details'>
                    <button onClick={this.toggleAccordion}>✕</button>
                    <h3>Why Should I Join?</h3>
                    <summary>
                        <p>
                            At Tarot.com we translate ancient wisdom for the modern world. Through our unique and
                            personalized content, we want to help guide our users toward understanding what humans
                            knew thousands of years ago … that the answers are within you!
                        </p>
                        <p>
                            By becoming a Tarot.com member, you'll join a community of more than six million members
                            who want to learn and grow as individuals and ultimately, make the world a better place.
                        </p>
                    </summary>
                    <h3>You'll also get:</h3>
                    <ul className='has-margin-20-left'>
                        <li>20 FREE Karma Coins® tokens</li>
                        <li>A FREE Tarot reading on your birthday</li>
                        <li>Personalized daily Tarot, Astrology & Numerology advice and tips</li>
                        <li>Special discounts on in-depth Tarot readings</li>
                    </ul>
                </aside>
            );
        }

        return null;
    }

    toggleAccordion = (e) => {
        e.preventDefault();
        this.setState({ accordionOpen: !this.state.accordionOpen });
    }

    setFormValues = (e) => {
        let state = this.state;

        state[e.target.name] = {
            value: e.target.type == 'checkbox' ? e.target.checked : e.target.value,
            error: null,
        };

        if (e.target.name == 'forum_name') {
            const error = isErrorForumName(e.target.value);
            state.formError = error ? true : false;
            state.forum_name = {
                value: e.target.value,
                error: error,
            };
        }

        if (
            e.target.name == 'birth_date_month'
            ||
            e.target.name == 'birth_date_day'
            ||
            e.target.name == 'birth_date_year'
        ) {
            const month = e.target.name == 'birth_date_month' ? e.target.value : this.state.birth_date_month.value;
            const day = e.target.name == 'birth_date_day' ? e.target.value : this.state.birth_date_day.value;
            const year = e.target.name == 'birth_date_year' ? e.target.value : this.state.birth_date_year.value;

            state.birth_date = {
                value: getBirthDate(month, day, year),
                error: null,
            };
            state.formError = null;
        } else if (e.target.name == 'birth_date') {
            state.birth_date = {
                value: dayjs(e.target.value).format('YYYY-MM-DD'),
                error: null,
            };
            state.formError = null;
        }

        this.setState(state);
    }
}

const mapStateToProps = (state) => ({
    user: state.user,
    ppc: state.cookie && state.cookie.PRIVACY_POLICY_CONSENT,
    submitting: state.form && state.form.submitting,
    submitted: state.form && state.form.submitted,
    emailError: state.user && state.user.emailError,
    forumNameError: state.user && state.user.forumNameError,
});

const mapDispatchToProps = (dispatch) => ({
    userSignupApi: (payload) => dispatch({ type: 'user:signup-api', payload: payload }),
    userUpdate: (payload) => dispatch({ type: 'user:update', payload: payload }),
    setSubmitting: (payload) => dispatch({ type: 'form:update', payload: { submitting: payload } }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
